import { CommApiInstance } from "Utils/CommApiInstance";

const MenbAdVrtInfoApi = async (
    gameSvcCd:string
) => {
    
    return await CommApiInstance.post(`memb/${gameSvcCd}/advrt_info`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
    
}
export default MenbAdVrtInfoApi;